import { alertHide, alertShow } from "./alert";
import { communicationsError, communicationsInProgress, communicationsSuccess } from "./communications";
import { databaseUpdate } from "./database";
import { join } from "../channel";
import { tournamentChatAppend } from "./tournament-chat";
import { trackPurchaseTicket } from "../analytics";

export const REMOVE_TOURNAMENT = "REMOVE_TOURNAMENT";
export const TOURNAMENT_ENTER_ERROR = "TOURNAMENT_ENTER_ERROR";
export const TOURNAMENT_ENTERING = "TOURNAMENT_ENTERING";
export const TOURNAMENT_ENTERED = "TOURNAMENT_ENTERED";

export function tournamentEnter(tournament, quantity, currency, isGameBoard) {
  var tournamentId = tournament.get("id");
  return (dispatch) => {
    dispatch({ type: TOURNAMENT_ENTERING, tournamentId });
    dispatch(alertHide());
    var channel = getTournamentChannel(dispatch, tournamentId);
    channel.push("enter_tournament", {
      ticket_quantity: quantity, // eslint-disable-line camelcase
      currency: currency
    }).receive("ok", ({ tickets }) => {
      if (tickets.length > 0) {
        trackPurchaseTicket(isGameBoard ? "Game Board" : "Tournament List", tournament, quantity, currency, tickets[0]);
      }
      dispatch({ type: TOURNAMENT_ENTERED, tournamentId });
    }).receive("error", ({ error }) => {
      dispatch({ type: TOURNAMENT_ENTER_ERROR, tournamentId, error });
    });
  };
}

export function tournamentMakePick(ticketId, tournamentId, raceId, raceEntrantId, alternatePickId) {
  return (dispatch) => {
    dispatch(alertHide());
    sendMakePick(dispatch, ticketId, tournamentId, raceId, raceEntrantId, alternatePickId)
      .receive("ok", (tables) => {
        dispatch(databaseUpdate(tables));
      })
      .receive("error", ({ message }) => {
        dispatch(alertShow("notification--error", "dw-blocked", "Error Submitting Pick", message));
      });
  };
}

function sendMakePick(dispatch, ticketId, tournamentId, raceId, raceEntrantId, alternatePickId) {
  var channel = getTournamentChannel(dispatch, tournamentId);
  return channel.push("submit_pick", {
    ticket_id: ticketId, // eslint-disable-line camelcase
    race_id: raceId, // eslint-disable-line camelcase
    race_entrant_id: raceEntrantId, // eslint-disable-line camelcase
    alternate_pick_id: raceEntrantId === alternatePickId ? undefined : alternatePickId // eslint-disable-line camelcase
  });
}

export function tournamentImportPicks(selectedTicketId, ticketId, tournamentId) {
  return (dispatch) => {
    dispatch(communicationsInProgress("tournamentImportPicks"));
    sendImportPicks(dispatch, selectedTicketId, ticketId, tournamentId)
      .receive("ok", (tables) => {
        dispatch(communicationsSuccess("tournamentImportPicks"));
        dispatch(databaseUpdate(tables));
      })
      .receive("error", ({ message }) => {
        dispatch(communicationsError("tournamentImportPicks", message));
      });
  };
}

function sendImportPicks(dispatch, selectedTicketId, ticketId, tournamentId) {
  var channel = getTournamentChannel(dispatch, tournamentId);
  return channel.push("import_picks", {
    selected_ticket_id: selectedTicketId, // eslint-disable-line camelcase
    ticket_id: ticketId // eslint-disable-line camelcase
  });
}

export function tournamentMakeAlternatePick(ticketId, tournamentId, raceId, raceEntrantId, alternatePickId) {
  return (dispatch) => {
    dispatch(alertHide());
    sendMakePick(dispatch, ticketId, tournamentId, raceId, raceEntrantId, alternatePickId).receive("ok", (tables) => {
      dispatch(databaseUpdate(tables));
    }).receive("error", ({ message }) => {
      dispatch(alertShow("notification--error", "dw-blocked", "Error Submitting Pick", message));
    });
  };
}

export function tournamentPostChatMessage(chatMessage, tournamentId) {
  return (dispatch) => {
    dispatch(alertHide());
    var channel = getTournamentChannel(dispatch, tournamentId);
    channel.push("post_chat_message", {
      chat_message: chatMessage //eslint-disable-line camelcase
    }).receive("error", ({ message }) => {
      dispatch(alertShow("notification--error", "dw-blocked", "Error Posting Message", message));
    });
  };
}

export function tournamentSubscribe(tournamentId) {
  return (dispatch) => getTournamentChannel(dispatch, tournamentId);
}

function getTournamentChannel(dispatch, tournamentId) {
  var handlers = {
    "new_chat_message": (tables) => {
      dispatch(tournamentChatAppend(tables));
    },
    "update": (tables) => {
      dispatch(databaseUpdate(tables));
    }
  };

  return join("tournament:" + tournamentId, (tables) => {
    dispatch(databaseUpdate(tables));
  }, undefined, handlers);
}

function getTournamentListChannel(dispatch) {
  var handlers = {
    "update": (tables) => {
      dispatch(databaseUpdate(tables));
    },
    "remove": (tables) => {
      dispatch({ type: REMOVE_TOURNAMENT, tables});
    }
  };
  return join("tournament:list:" + window.env.whiteLabelSite, (tables) => {
    dispatch(databaseUpdate(tables));
  }, undefined, handlers);
}

export function getUpcomingTournaments(dispatch) {
  dispatch(communicationsInProgress("fetchUpcomingTournaments"));

  var channel = getTournamentListChannel(dispatch);
  channel.push("get_upcoming", {}).receive("ok", (tables) => {
    dispatch(databaseUpdate(tables));
    dispatch(communicationsSuccess("fetchUpcomingTournaments"));
  }).receive("error", ({ message }) => {
    dispatch(communicationsError("fetchUpcomingTournaments", message));
  });
}

export function getStartedTournaments(tag) {
  return (dispatch) => {
    dispatch(communicationsInProgress("fetchStartedTournaments"));

    var channel = getTournamentListChannel(dispatch);
    channel.push("get_started", { tag }).receive("ok", (tables) => {
      dispatch(databaseUpdate(tables));
      dispatch(communicationsSuccess("fetchStartedTournaments"));
    }).receive("error", ({ message }) => {
      dispatch(communicationsError("fetchStartedTournaments", message));
    });
  };
}
